// Initialize Sentry first (before any other imports) to capture all errors
import { initSentry } from './lib/sentry/config';
initSentry();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
